import api from './api'

export interface ChatMessage {
  id?: string
  message: string
  sender_firebase_uid: string
  sender_role: string
  sender_name?: string
  created_at?: unknown
}

export interface ChatItem {
  id: string
  category: string
  status?: string
  last_message?: string
  updated_at?: unknown
}

export interface FirebaseAuthPayload {
  success: boolean
  firebase_uid: string
  firebase_token?: string
  firebase_config?: Record<string, string>
  user?: {
    id?: number
    name?: string
    email?: string
    company_id?: number
    company_name?: string
    company_code?: string
  }
}

export const chatService = {
  async getFirebaseAuth(): Promise<FirebaseAuthPayload> {
    const response = await api.get('/chat/firebase-auth')
    return response.data
  },
}

export default chatService

